import type { FinOpsInsightPanel } from "@/types";

/** Static snapshot for the right-hand assessment insights column (mock). */
export const mockInsightPanelSnapshot: FinOpsInsightPanel = {
  estimatedMonthlySavings: {
    amountLabel: "$128,400",
    subtitle: "Modeled from utilization + commitment deltas vs. last 30 days.",
    breakdown: [
      { label: "Rightsizing (non-prod)", value: "$62,100" },
      { label: "Commitment coverage gaps", value: "$41,200" },
      { label: "Egress & cross-region", value: "$25,100" },
    ],
  },
  // riskProfile: {
  //   level: "moderate",
  //   summary:
  //     "Spend volatility is concentrated in compute and data transfer. Governance signals are mixed across accounts.",
  //   signals: [
  //     "Tag coverage uneven on top cost centers",
  //     "Autoscaling present but conservative in staging",
  //     "RI/SP coverage below target for steady workloads",
  //   ],
  // },
  confidenceLevel: {
    percent: 72,
    label: "Medium–high",
    rationale:
      "Based on partial billing export and stated scope. Confidence rises as utilization telemetry is attached.",
  },
  // detectedContext: {
  //   cloudScope: "AWS (multi-account), Kubernetes on EKS in two regions",
  //   billingCadence: "Monthly invoice, cost & usage file available weekly",
  //   primaryServices: ["EC2", "EKS", "RDS", "S3", "Data transfer"],
  //   orgHints: [
  //     "FinOps sponsor: Platform engineering",
  //     "Primary KPI: cost per workload vs. SLO adherence",
  //   ],
  // },
  // topOpportunities: [
  //   {
  //     id: "opp-1",
  //     title: "Rightsize non-prod node groups",
  //     impact: "high",
  //     effort: "medium",
  //     detail:
  //       "Several instance families run below 20% CPU at p95 for sustained windows.",
  //   },
  //   {
  //     id: "opp-2",
  //     title: "Increase SP coverage on steady RDS",
  //     impact: "medium",
  //     effort: "low",
  //     detail: "Stable OLTP footprint with predictable monthly run cost.",
  //   },
  //   {
  //     id: "opp-3",
  //     title: "Regional egress review",
  //     impact: "medium",
  //     effort: "high",
  //     detail: "Cross-AZ and cross-region patterns correlate with data pipeline jobs.",
  //   },
  // ],
  assumptionsAndConstraints: {
    assumptions: [
      "Billing dimensions align with workload ownership in CMDB.",
      "Non-prod environments may tolerate more aggressive schedules.",
    ],
    constraints: [
      "No changes to production SLOs this quarter.",
      "Preferred commitment term: 1-year SP over 3-year RI.",
    ],
  },
};
